function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M99.684 68.051v19.431c0 5.516-4.513 10.028-10.029 10.028H16.947c-5.516 0-10.029-4.512-10.029-10.028V68.051M52.822 2.498v74.384",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.126 51.49l27.696 28.59 27.695-28.59",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 5,
  strokeLinejoin: "miter"
});

function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 106 106",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTA2IDEwNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiPgogIDxwYXRoIGQ9Ik05OS42ODQgNjguMDUxdjE5LjQzMWMwIDUuNTE2LTQuNTEzIDEwLjAyOC0xMC4wMjkgMTAuMDI4SDE2Ljk0N2MtNS41MTYgMC0xMC4wMjktNC41MTItMTAuMDI5LTEwLjAyOFY2OC4wNTFNNTIuODIyIDIuNDk4djc0LjM4NCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iNSIvPgogIDxwYXRoIGQ9Ik0yNS4xMjYgNTEuNDlsMjcuNjk2IDI4LjU5IDI3LjY5NS0yOC41OSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iNSIgc3Ryb2tlLWxpbmVqb2luPSJtaXRlciIvPgo8L3N2Zz4=";
export { SvgDownload as ReactComponent };